// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"80":"39264cf6dfccf910","459":"a76e2efc049a200c","515":"cc97f79d328e6617","804":"419167c7881aad96","888":"a8869767afbb5391","938":"23b6bc4c4ce6d2eb"}[chunkId] + ".css";
};